// Public-site switches: flip a value and redeploy.
// Leadership Team page (/about/team) plus every nav/footer link and leadership section that points to it.
export const TEAM_PAGE_LIVE = true;
